module.exports = __webpack_public_path__ + "img/notice.19ad49d7.png";